export default {
  'component.logger.label.endpoint': 'Endpoint',
  'component.logger.label.token': 'Token',
  'component.logger.label.applicationName': 'Application name',
  'component.logger.label.source': 'Source',
};
